import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import isEmpty from 'lodash-es/isEmpty';
import PropTypes from 'prop-types';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useKeyboardKeys, KEYCODES } from '@panneau/core/hooks';
import Button from '@panneau/element-button';
import Icon from '@panneau/element-icon';
import TextField from '@panneau/field-text';

var messages = defineMessages({
  search: {
    "id": "XrzzDc",
    "defaultMessage": [{
      "type": 0,
      "value": "Search"
    }]
  }
});
var propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  position: PropTypes.string,
  width: PropTypes.number,
  delay: PropTypes.number,
  className: PropTypes.string
};
var defaultProps = {
  name: 'q',
  value: null,
  placeholder: null,
  position: null,
  width: null,
  delay: 500,
  className: null
};
var SearchFilter = function SearchFilter(_ref) {
  var name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    position = _ref.position,
    width = _ref.width,
    delay = _ref.delay,
    className = _ref.className;
  var intl = useIntl();
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var hasChanged = useRef(null);
  var onInputChange = useCallback(function (newValue) {
    setSearchValue(newValue !== '' ? newValue : null);
    hasChanged.current = true;
  }, [setSearchValue]);
  var onValueChange = useCallback(function (newValue) {
    setSearchValue(newValue !== '' ? newValue : null);
    hasChanged.current = false;
  }, [setSearchValue]);
  var onSubmit = useCallback(function (e) {
    e.preventDefault();
    hasChanged.current = false;
    if (onChange !== null) {
      onChange(searchValue);
    }
  }, [searchValue, onChange]);
  var onReset = useCallback(function () {
    setSearchValue(null);
    hasChanged.current = false;
    if (onChange !== null) {
      onChange(null);
    }
  }, [onChange, delay, setSearchValue]);
  useEffect(function () {
    var timeout = null;
    if (hasChanged.current && delay !== null) {
      timeout = setTimeout(function () {
        onChange(searchValue);
        hasChanged.current = false;
      }, delay);
    }
    return function () {
      clearTimeout(timeout);
    };
  }, [searchValue, onChange, delay, hasChanged]);

  // Keep in sync
  useEffect(function () {
    onValueChange(value);
  }, [value, onValueChange]);
  var active = !isEmpty(value);
  var canClear = !isEmpty(searchValue);
  useKeyboardKeys(_defineProperty({}, KEYCODES.ESCAPE, onReset));
  return /*#__PURE__*/React.createElement("form", {
    className: className,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-group "
  }, position === 'left' ? /*#__PURE__*/React.createElement(Button, {
    theme: active ? 'primary' : 'secondary',
    type: "submit",
    onClick: onSubmit,
    style: {
      zIndex: 0
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "search",
    bold: true
  })) : null, /*#__PURE__*/React.createElement(TextField, {
    type: "search",
    name: name,
    value: searchValue,
    theme: "light",
    onChange: onInputChange,
    placeholder: placeholder || intl.formatMessage(messages.search),
    style: {
      width: width !== null ? width - 42 : null
    }
  }), canClear ? /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: onReset,
    className: "position-absolute top-0 me-0 border-0",
    outline: false,
    style: {
      zIndex: 10,
      right: position !== 'left' ? "40px" : 0
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "x-circle"
  })) : null, position !== 'left' ? /*#__PURE__*/React.createElement(Button, {
    theme: active ? 'primary' : 'secondary',
    type: "submit",
    onClick: onSubmit,
    style: {
      zIndex: 0
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "search",
    bold: true
  })) : null));
};
SearchFilter.propTypes = propTypes;
SearchFilter.defaultProps = defaultProps;

export { SearchFilter as default };
